export default __webpack_public_path__ + "static/genclerbirligi-logo-10844e2fdc8482af851e8df74c196c1a.png";